export default "__VITE_ASSET__ByYbj_h$__"